import { apiCall, apiCallPublic, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  getUserInfoMock,
  regionProvinceListMock,
  successMock,
  updateSuccessMock,
} from './mock';
import { authPath } from '../../utils/paths';

export default {
  getInfo: (uid) => {
    if (shouldUseMock()) {
      return getUserInfoMock();
    }
    return apiCall(`${baseUrl}${authPath}user/detail`, 'GET');
  },
  updateEmail: (payload) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(`${baseUrl}${authPath}user/email/update`, 'POST', payload);
  },
  updatePassword: (payload) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${authPath}user/password/update`,
      'POST',
      payload
    );
  },
  regionProvinceSet: (payload) => {
    if (shouldUseMock()) {
      return updateSuccessMock();
    }
    return apiCall(
      `${baseUrl}${authPath}user/regionprovince/set`,
      'POST',
      payload
    );
  },
  getRegionProvinceList: () => {
    if (shouldUseMock()) {
      return regionProvinceListMock();
    }
    return apiCallPublic(`${baseUrl}${authPath}provinceregion/list`, 'GET');
  },
};
